module.exports = __webpack_public_path__ + "img/9281920.png";